import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { IFormFieldInteger } from './index.js';
import { IntegerDisplay } from './IntegerDisplay.js';

interface IProps {
  value?: number;
  previousValue?: number | null;
  onClose: () => void;
  config: IFormFieldInteger;
}

export const IntegerDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: IProps) => {
  const prevZeroState = !previousValue;
  const currentZeroState = !value;
  const label = config.params.labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? zeroState : <IntegerDisplay value={previousValue} />}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? zeroState : <IntegerDisplay value={value} />}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
